import React from 'react';
import { ArrowRightIcon, GiftIcon, SparklesIcon, TicketIcon } from 'lucide-react';
interface OffersEngagementCardsProps {
  onOpenCoupons: () => void;
  onOpenSpin: () => void;
  onOpenScratch: () => void;
}
const previewCoupons: Array<{
  code: string;
  label: string;
  tone: string;
}> = [{
  code: 'SAVE20',
  label: '20% OFF',
  tone: 'border-rose-200 bg-rose-50 text-rose-800'
}, {
  code: 'WELCOME10',
  label: '10% OFF',
  tone: 'border-sky-200 bg-sky-50 text-sky-800'
}, {
  code: 'FREESHIP',
  label: 'FREE DELIVERY',
  tone: 'border-amber-200 bg-amber-50 text-amber-800'
}];
export function OffersEngagementCards({
  onOpenCoupons,
  onOpenSpin,
  onOpenScratch
}: OffersEngagementCardsProps) {
  return <section className="grid w-full gap-4 px-4 lg:grid-cols-3" aria-label="Rewards and coupons" data-id="element-4862" data-mp="3ikdl0ktdfk9j">
      <button type="button" onClick={onOpenCoupons} className="group flex min-h-[275px] flex-col rounded-2xl border border-brand-border bg-white p-5 text-left shadow-sm transition-[box-shadow,border-color] duration-150 hover:border-sage hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 md:p-6" data-id="element-4863" data-mp="34l5ibhy01u0l">
        <div className="flex items-start justify-between gap-4" data-id="element-4864" data-mp="24au8l16qhvby">
          <div className="flex items-center gap-3" data-id="element-4865" data-mp="24881f2nr9hu9">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand" data-id="element-4866" data-mp="1zcspwhd7zy10">
              <TicketIcon className="h-5 w-5" aria-hidden="true" data-id="element-4867" data-mp="1bm6j0teycjsl" />
            </span>
            <div data-id="element-4868" data-mp="16o52af500wka">
              <p className="text-xs font-bold uppercase tracking-wide text-sage-dark" data-id="element-4869" data-mp="16on19jj1povw">Save more today</p>
              <h2 className="mt-0.5 text-xl font-bold text-gray-900" data-id="element-4870" data-mp="1ldt2te5cvr6y">Your available coupons</h2>
            </div>
          </div>
          <span className="rounded-full bg-sage-light px-2.5 py-1 text-xs font-bold text-sage-dark" data-id="element-4871" data-mp="sv5msd57v2cq">4 offers</span>
        </div>

        <div className="mt-5 grid gap-2.5 sm:grid-cols-3" data-id="element-4872" data-mp="nv9i0bop36w4">
          {previewCoupons.map(coupon => <div key={coupon.code} className={`rounded-xl border p-3 ${coupon.tone}`} data-id="element-4873" data-mp="1djon4vnyusf2">
              <p className="text-[11px] font-bold tracking-wide" data-id="element-4874" data-mp="1hl046csry5bn">{coupon.label}</p>
              <p className="mt-2 truncate font-mono text-sm font-black tracking-tight" data-id="element-4875" data-mp="1mc9tfcaev6n0">{coupon.code}</p>
            </div>)}
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-4876" data-mp="1rb3652hvitm4">
          <p className="text-sm text-gray-600" data-id="element-4877" data-mp="unf1nnaqizl1">Choose a code and apply it at checkout.</p>
          <span className="ml-3 inline-flex shrink-0 items-center gap-1 text-sm font-bold text-brand" data-id="element-4878" data-mp="ynpgzqkf32ck">
            View all
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-4879" data-mp="13od4i29ft121" />
          </span>
        </div>
      </button>

      <button type="button" onClick={onOpenSpin} className="group relative flex min-h-[275px] flex-col overflow-hidden rounded-2xl border border-brand-dark bg-brand p-5 text-left text-white shadow-sm transition-shadow duration-150 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 md:p-6" data-id="element-4880" data-mp="2f0xhffmjoa49">
        <div className="flex items-start justify-between gap-4" data-id="element-4881" data-mp="3urgjdoarx6sh">
          <div className="flex items-center gap-3" data-id="element-4882" data-mp="3pu7znj9z8up4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white" data-id="element-4883" data-mp="3ptes4g37215x">
              <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-4884" data-mp="3lpqjdu2tszj3" />
            </span>
            <div data-id="element-4885" data-mp="3grp1vdl1t89q">
              <p className="text-xs font-bold uppercase tracking-wide text-white/70" data-id="element-4886" data-mp="3gvcqpzfjt6i4">A surprise offer</p>
              <h2 className="mt-0.5 text-xl font-bold text-white" data-id="element-4887" data-mp="36uu3qvsot9vz">Spin & Win</h2>
            </div>
          </div>
          <span className="rounded-full border border-white/25 bg-white/10 px-2.5 py-1 text-xs font-bold text-white" data-id="element-4888" data-mp="1a2ah0cgybh6f">Free spin</span>
        </div>

        <div className="mt-5 flex items-center justify-between gap-5" data-id="element-4889" data-mp="153z39qnjcmix">
          <div data-id="element-4890" data-mp="1d56rhj0rcwxa">
            <p className="max-w-[185px] text-sm leading-6 text-white/85" data-id="element-4891" data-mp="1d5gfx265mw0v">
              Spin the wheel for a chance to unlock an exclusive discount.
            </p>
            <div className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-white px-3 py-2 text-sm font-bold text-brand" data-id="element-4892" data-mp="136h97p4y9agi">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-4893" data-mp="183r59nmugkdb" />
              Start your spin
            </div>
          </div>
          <span className="relative flex h-24 w-24 shrink-0 items-center justify-center rounded-full border-4 border-white bg-[#F6C945] shadow-lg" aria-hidden="true" data-id="element-4894" data-mp="ubkrg875yph1">
            <span className="absolute inset-y-0 left-1/2 w-1 -translate-x-1/2 bg-[#D85B5B]" data-id="element-4895" data-mp="kgsqqviabmi1" />
            <span className="absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 bg-[#65A5D9]" data-id="element-4896" data-mp="pfm3umtntbho" />
            <span className="absolute inset-3 rotate-45 border-y-4 border-[#F0E9D4]" data-id="element-4897" data-mp="bfulk9w418xv" />
            <span className="relative flex h-9 w-9 items-center justify-center rounded-full border-2 border-white bg-brand text-xs font-black text-white" data-id="element-4898" data-mp="fgmwd7kmrlw9">%</span>
          </span>
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-white/20 pt-4" data-id="element-4899" data-mp="3nyxan2zzm0c6">
          <p className="text-sm text-white/80" data-id="element-4900" data-mp="5talnw0t8pv3">One free spin per visit.</p>
          <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-4901" data-mp="to6vi5c31k6" />
        </div>
      </button>

      <button type="button" onClick={onOpenScratch} className="group flex min-h-[275px] flex-col rounded-2xl border border-amber-200 bg-[#FFFBEB] p-5 text-left shadow-sm transition-[box-shadow,border-color] duration-150 hover:border-amber-300 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 md:p-6" data-id="element-4902" data-mp="fpnllbmy7zya">
        <div className="flex items-start justify-between gap-4" data-id="element-4903" data-mp="yhy99y917rbt">
          <div className="flex items-center gap-3" data-id="element-4904" data-mp="tj4ve4pu1yb4">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#FDE68A] text-amber-800" data-id="element-4905" data-mp="tg8zelxjpjpb">
              <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-4906" data-mp="3rbwwxo00cxso" />
            </span>
            <div data-id="element-4907" data-mp="3r9kd15aowdcz">
              <p className="text-xs font-bold uppercase tracking-wide text-amber-800" data-id="element-4908" data-mp="5vq5rn2sqcu">Instant reward</p>
              <h2 className="mt-0.5 text-xl font-bold text-gray-900" data-id="element-4909" data-mp="4wvo907xlegx">Scratch & Win</h2>
            </div>
          </div>
          <span className="rounded-full bg-white px-2.5 py-1 text-xs font-bold text-amber-800 shadow-sm" data-id="element-4910" data-mp="9udnfyw5cfbq">1 card</span>
        </div>

        <div className="mt-5 flex min-h-[108px] items-center rounded-xl border-2 border-dashed border-amber-300 bg-white px-4" data-id="element-4911" data-mp="esoygcy6gvvj">
          <div className="w-full text-center" data-id="element-4912" data-mp="nv7vuhj72gae">
            <p className="text-sm font-bold text-gray-900" data-id="element-4913" data-mp="ntwvyssvdsok">Your mystery offer is ready</p>
            <p className="mt-1 text-sm text-gray-600" data-id="element-4914" data-mp="2kojholnqkouz">Scratch to reveal your discount.</p>
            <span className="mt-4 inline-flex items-center gap-1.5 rounded-lg bg-[#F6C945] px-3 py-2 text-sm font-bold text-amber-950" data-id="element-4915" data-mp="2plrsu2agvsmq">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-4916" data-mp="2i4d4roh59o2a" />
              Reveal offer
            </span>
          </div>
        </div>

        <div className="mt-auto flex items-center justify-between border-t border-amber-200 pt-4" data-id="element-4917" data-mp="28cz6fk0xiuaq">
          <p className="text-sm text-gray-600" data-id="element-4918" data-mp="23efije2rz8fq">A new surprise awaits.</p>
          <ArrowRightIcon className="h-5 w-5 text-amber-800 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-4919" data-mp="23cb6u9ymx54w" />
        </div>
      </button>
    </section>;
}